function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M8 3.933c.773 0 1.4.627 1.4 1.4 0 .774-.627 1.4-1.4 1.4-.773 0-1.4-.626-1.4-1.4 0-.773.627-1.4 1.4-1.4m0 6c1.98 0 4.067.974 4.067 1.4v.734H3.933v-.734c0-.426 2.087-1.4 4.067-1.4m0-7.266c-1.473 0-2.667 1.193-2.667 2.666C5.333 6.807 6.527 8 8 8c1.473 0 2.667-1.193 2.667-2.667 0-1.473-1.194-2.666-2.667-2.666zm0 6c-1.78 0-5.333.893-5.333 2.666v1.334c0 .366.3.666.666.666h9.334c.366 0 .666-.3.666-.666v-1.334C13.333 9.56 9.78 8.667 8 8.667z",
  transform: "translate(-32 -543) translate(16 254) translate(0 61) translate(16 228)"
}))))));

function SvgIconPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/icon-person.66762108.svg";
export { ForwardRef as ReactComponent };